module.exports = __webpack_public_path__ + "020d9a9922da416c33e1d54b8ec81953.png";